import React from "react";

export const NavBar = () => {

    return (
        <nav>
            <div className="clearfix">

                <a href="index.html" className="logo"><img
                    src={process.env.PUBLIC_URL + "/lager/assets/images/logo.png"} alt=""/></a>


                <div className="navigation navigation-pre clearfix">
                    <div className="row">
                        <div className="col-md-3">
                            <a href="#"><i className="icon icon-heart-pulse"></i> Help center</a>
                        </div>
                        <div className="col-md-3">
                            <a href="#"><i className="icon icon-cart"></i> Shipping & Returns</a>
                        </div>
                        <div className="col-md-3">
                            <a href="#"><i className="icon icon-cog"></i> Gift cards</a>
                        </div>
                        <div className="col-md-3">
                            <a href="#"><i className="icon icon-map"></i> Store locator</a>
                        </div>
                    </div>
                </div>


                <div className="navigation navigation-top clearfix">
                    <ul>
                        <li className="left-side"><a href="index.html" className="logo-icon"><img
                            src={process.env.PUBLIC_URL + "/lager/assets/images/icon.png"}
                            alt="Alternate Text"/></a></li>
                        <li className="left-side"><a href="#">Man</a></li>

                        <li className="left-side active"><a href="#">Man</a></li>

                        <li className="left-side"><a href="#">Woman</a></li>
                        <li className="left-side"><a href="#">Kids</a></li>
                        <li><a className="open-login"><i className="icon icon-user"></i></a>
                        </li>
                        <li><a className="open-search"><i
                            className="icon icon-magnifier"></i></a></li>
                        <li><a className="open-cart"><i className="icon icon-cart"></i>
                            <span>4</span></a></li>
                    </ul>
                </div>


                <div className="navigation navigation-main">
                    <a href="#" className="open-login"><i className="icon icon-user"></i></a>
                    <a href="#" className="open-search"><i className="icon icon-magnifier"></i></a>
                    <a href="#" className="open-cart"><i className="icon icon-cart"></i> <span>4</span></a>
                    <a href="#" className="open-menu"><i className="icon icon-menu"></i></a>
                    <div className="floating-menu">

                        <div className="close-menu-wrapper">
                            <span className="close-menu"><i className="icon icon-cross"></i></span>
                        </div>
                        <ul>
                            <li>
                                <a href="#">Home <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul>
                                                    <li className="label">Homepages</li>
                                                    <li><a href="index.html">Home - Slider</a></li>
                                                    <li><a href="index-2.html">Home - Tabsy</a></li>
                                                    <li><a href="index-3.html">Home intro</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="#">Pages <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul>
                                                    <li className="label">Single dropdown</li>
                                                    <li><a href="about.html">About us</a></li>
                                                    <li><a href="contact.html">Contact</a></li>
                                                    <li><a href="404.html">Not found 404</a></li>
                                                    <li><a href="login.html">Login & Register</a></li>
                                                    <li><a href="email-receipt.html">Email - Receipt template</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="#">Shop <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul>
                                                    <li className="label">Product page</li>
                                                    <li><a href="category.html">Products categories</a></li>
                                                    <li><a href="products-grid.html">Products grid</a></li>
                                                    <li><a href="products-list.html">Products list</a></li>
                                                    <li><a href="products-grid-intro.html">Products grid intro</a>
                                                    </li>
                                                    <li><a href="products-topbar.html">Products topbar filter</a>
                                                    </li>
                                                    <li><a href="product.html">Product overview</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="#">Blog <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul>
                                                    <li className="label">Blog pages</li>
                                                    <li><a href="blog-grid.html">Blog grid</a></li>
                                                    <li><a href="blog-list.html">Blog list</a></li>
                                                    <li><a href="blog-grid-fullpage.html">Blog fullpage</a></li>
                                                    <li><a href="ideas.html">Blog ideas</a></li>
                                                    <li><a href="article.html">Article</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="#">Checkout <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul>
                                                    <li className="label">Checkout</li>
                                                    <li><a href="checkout-1.html">Checkout - Cart items</a></li>
                                                    <li><a href="checkout-2.html">Checkout - Delivery</a></li>
                                                    <li><a href="checkout-3.html">Checkout - Payment</a></li>
                                                    <li><a href="checkout-4.html">Checkout - Receipt</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a href="index.html">Boxmenu <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown">
                                    <div className="navbar-box">
                                        <div className="box-lg">
                                            <div className="box clearfix">
                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Washers & Dryers
                                                            </li>
                                                            <li><a href="#">Dishwashers</a></li>
                                                            <li><a href="#">Ovens & Ranges</a></li>
                                                            <li><a href="#">Irons & Ironing Boards</a></li>
                                                            <li><a href="#">Heating & Cooling</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Kitchen Appliances
                                                            </li>
                                                            <li><a href="#">Coffee Makers</a></li>
                                                            <li><a href="#">Microwaves</a></li>
                                                            <li><a href="#">Blenders</a></li>
                                                            <li><a href="#">Slow Cookers</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Freezers
                                                            </li>
                                                            <li><a href="#">Mini Freezers</a></li>
                                                            <li><a href="#">Ice Makers</a></li>
                                                            <li><a href="#">Chest Freezers</a></li>
                                                            <li><a href="#">Upright Freezers</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> TV & Video
                                                            </li>
                                                            <li><a href="#">TVs</a></li>
                                                            <li><a href="#">DVD & Blu-ray Players</a></li>
                                                            <li><a href="#">Home Audio & Theater</a></li>
                                                            <li><a href="#">TVs Accessories</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Cell phones
                                                            </li>
                                                            <li><a href="#">Straight Talk Phones</a></li>
                                                            <li><a href="#">Unlocked Phones</a></li>
                                                            <li><a href="#">Contract Phones</a></li>
                                                            <li><a href="#">No-Contract Phones</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> iPad & Tablets
                                                            </li>
                                                            <li><a href="#">iPad</a></li>
                                                            <li><a href="#">Windows Tablets</a></li>
                                                            <li><a href="#">Android Tablets</a></li>
                                                            <li><a href="#">Accessories</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Computers
                                                            </li>
                                                            <li><a href="#">Laptops</a></li>
                                                            <li><a href="#">Desktops</a></li>
                                                            <li><a href="#">PC Gaming</a></li>
                                                            <li><a href="#">Printers & Supplies</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Floor Care
                                                            </li>
                                                            <li><a href="#">Upright Vacuums</a></li>
                                                            <li><a href="#">Stick Vacuums</a></li>
                                                            <li><a href="#">Robotic Vacuums</a></li>
                                                            <li><a href="#">Handheld Vacuums</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <ul>
                                                            <li className="label"><i
                                                                className="icon icon-star"></i> Refrigerators
                                                            </li>
                                                            <li><a href="#">Mini Fridges</a></li>
                                                            <li><a href="#">Kegerators</a></li>
                                                            <li><a href="#">Beverage Refrigerators</a></li>
                                                            <li><a href="#">Wine Refrigerators</a></li>
                                                            <li className="more"><a href="#"><i
                                                                className="icon icon-chevron-right"></i> More</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-sm">
                                            <div className="image">
                                                <img
                                                    src={process.env.PUBLIC_URL + "/lager/assets/images/menu-item-1.jpg"}
                                                    alt="Alternate Text"/>
                                                <img
                                                    src={process.env.PUBLIC_URL + "/lager/assets/images/menu-item-2.jpg"}
                                                    alt="Alternate Text"/>
                                            </div>
                                            <div className="box">
                                                <div className="h2">Shop Electronics</div>
                                                <div className="clearfix">
                                                    <p>Homes that differ in terms of style, concept and
                                                        architectural solutions have been furnished by Furniture
                                                        Factory. These spaces tell of an international lifestyle
                                                        that expresses modernity, research and a creative
                                                        spirit.</p>
                                                    <a className="btn btn-clean btn-big" href="products-grid.html">Shop
                                                        now</a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </li>

                            <li>
                                <a href="#">Megamenu <span className="open-dropdown"><i
                                    className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <div className="row">
                                                    <div className="clearfix">
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Computers
                                                                </li>
                                                                <li><a href="#">Laptops</a></li>
                                                                <li><a href="#">Desktops</a></li>
                                                                <li><a href="#">PC Gaming</a></li>
                                                                <li><a href="#">Printers & Supplies</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Vacuums
                                                                </li>
                                                                <li><a href="#">Upright Vacuums</a></li>
                                                                <li><a href="#">Stick Vacuums</a></li>
                                                                <li><a href="#">Robotic Vacuums</a></li>
                                                                <li><a href="#">Handheld Vacuums</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Refrigerators
                                                                </li>
                                                                <li><a href="#">Mini Fridges</a></li>
                                                                <li><a href="#">Kegerators</a></li>
                                                                <li><a href="#">Beverage Refrigerators</a></li>
                                                                <li><a href="#">Wine Refrigerators</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Appliances &
                                                                    Accessories
                                                                </li>
                                                                <li><a href="#">Dishwasher Parts</a></li>
                                                                <li><a href="#">Oven & Ranges Parts</a></li>
                                                                <li><a href="#">Refrigerator & Freezer Parts</a>
                                                                </li>
                                                                <li><a href="#">Washer & Dryer Parts</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="clearfix">
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Freezers
                                                                </li>
                                                                <li><a href="#">Mini Freezers</a></li>
                                                                <li><a href="#">Ice Makers</a></li>
                                                                <li><a href="#">Chest Freezers</a></li>
                                                                <li><a href="#">Upright Freezers</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> TV & Video
                                                                </li>
                                                                <li><a href="#">TVs</a></li>
                                                                <li><a href="#">DVD & Blu-ray Players</a></li>
                                                                <li><a href="#">Home Audio & Theater</a></li>
                                                                <li><a href="#">TVs Accessories</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> Cell phones
                                                                </li>
                                                                <li><a href="#">Straight Talk Phones</a></li>
                                                                <li><a href="#">Unlocked Phones</a></li>
                                                                <li><a href="#">Contract Phones</a></li>
                                                                <li><a href="#">No-Contract Phones</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <ul>
                                                                <li className="label"><i
                                                                    className="icon icon-star"></i> iPad & Tablets
                                                                </li>
                                                                <li><a href="#">iPad</a></li>
                                                                <li><a href="#">Windows Tablets</a></li>
                                                                <li><a href="#">Android Tablets</a></li>
                                                                <li><a href="#">Accessories</a></li>
                                                                <li className="more"><a href="#"><i
                                                                    className="icon icon-chevron-right"></i> More</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li><a href="shortcodes.html">Shortcodes</a></li>

                            <li className="nav-settings">
                                <a href="#"><span className="nav-settings-value">USD</span> <span
                                    className="open-dropdown"><i className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul className="nav-settings-list">
                                                    <li><a href="#">USD</a></li>
                                                    <li><a href="#">EUR</a></li>
                                                    <li><a href="#">GBP</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-settings">
                                <a href="#"><span className="nav-settings-value">ENG</span> <span
                                    className="open-dropdown"><i className="fa fa-angle-down"></i></span></a>
                                <div className="navbar-dropdown navbar-dropdown-single">
                                    <div className="navbar-box">
                                        <div className="box-full">
                                            <div className="box clearfix">
                                                <ul className="nav-settings-list">
                                                    <li><a href="#">ENG</a></li>
                                                    <li><a href="#">GER</a></li>
                                                    <li><a href="#">لعربية</a></li>
                                                    <li><a href="#">עִבְרִית</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>


                <div className="search-wrapper">
                    <input className="form-control" placeholder="Search..."/>
                    <button className="btn btn-main">Go!</button>
                </div>


                <div className="login-wrapper">
                    <div className="h4">Sign in</div>
                    <form>
                        <div className="form-group">
                            <input type="email" className="form-control" id="exampleInputEmail1"
                                   placeholder="Email"/>
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" id="exampleInputPassword1"
                                   placeholder="Password"/>
                        </div>
                        <div className="form-group">
                            <a href="#forgotpassword" className="open-popup">Forgot password?</a>
                            <a href="#createaccount" className="open-popup">Don't have an account?</a>
                        </div>
                        <button type="submit" className="btn btn-block btn-main">Submit</button>
                    </form>
                </div>


                <div className="cart-wrapper">
                    <div className="checkout">
                        <div className="clearfix">


                            <div className="row">

                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img
                                            src={process.env.PUBLIC_URL + "/lager/assets/images/product-1.png"}
                                            alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div><a href="product.html">Product item</a></div>
                                        <small>Product category</small>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" onChange={() => {
                                        }} className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final">$ 1.998</span>
                                        <span className="discount">$ 2.666</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>


                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img
                                            src={process.env.PUBLIC_URL + "/lager/assets/images/product-2.png"}
                                            alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div><a href="product.html">Product item</a></div>
                                        <small>Product category</small>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" onChange={() => {
                                        }} className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final">$ 1.998</span>
                                        <span className="discount">$ 2.666</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>


                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img
                                            src={process.env.PUBLIC_URL + "/lager/assets/images/product-3.png"}
                                            alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div><a href="product.html">Product item</a></div>
                                        <small>Product category</small>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" onChange={() => {
                                        }} className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final">$ 1.998</span>
                                        <span className="discount">$ 2.666</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>


                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img
                                            src={process.env.PUBLIC_URL + "/lager/assets/images/product-4.png"}
                                            alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div><a href="product.html">Product item</a></div>
                                        <small>Product category</small>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" onChange={() => {
                                        }} className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final">$ 1.998</span>
                                        <span className="discount">$ 2.666</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>
                            </div>

                            <hr/>


                            <div className="clearfix">
                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>Discount 15%</strong>
                                    </div>
                                    <div>
                                        <span>$ 159,00</span>
                                    </div>
                                </div>

                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>Shipping</strong>
                                    </div>
                                    <div>
                                        <span>$ 30,00</span>
                                    </div>
                                </div>

                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>VAT</strong>
                                    </div>
                                    <div>
                                        <span>$ 59,00</span>
                                    </div>
                                </div>
                            </div>

                            <hr/>


                            <div className="clearfix">
                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>Total</strong>
                                    </div>
                                    <div>
                                        <div className="h4 title">$ 1259,00</div>
                                    </div>
                                </div>
                            </div>


                            <div className="cart-block-buttons clearfix">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <a href="products-grid.html" className="btn btn-clean-dark">Continue
                                            shopping</a>
                                    </div>
                                    <div className="col-xs-6 text-right">
                                        <a href="checkout-1.html" className="btn btn-main"><span
                                            className="icon icon-cart"></span> Checkout</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}